import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	recent: {
		id: 'atlassian-navigation.filters.menu.recent-content.recent',
		defaultMessage: 'Recent',
		description: 'Text on the recent title.',
	},
});
